function transformOpgaveKompleksetV1DataToV2(data, envelope) {
  if (data.version === "2") {
    return data;
  }
  return {
    version: "2",
    descriptors: data.course.map(v1Descriptor => {
      if (Array.isArray(v1Descriptor)) {
        return {
          id: crypto.randomUUID(),
          type: "stack",
          title: "",
          tasks: v1Descriptor.map(task => transformV1Task(task, data))
        };
      } else {
        switch (v1Descriptor.type) {
          case "task":
            return transformV1Task(v1Descriptor, data);
          case "folder":
            return {
              id: v1Descriptor.id,
              title: v1Descriptor.title,
              type: "folder",
              tasksToTake: v1Descriptor.tasks
            };
        }
      }
    }),
    settings: {
      allowedAttempts: data.settings.allowedAttempts,
      flowType: transformSettignsToFlowType(data, envelope),
      standalone: {
        audience: data.layout?.type ?? "default",
        accentColor: data.layout?.colors?.primary ?? null,
        speechSynthesis: {
          primaryLanguage: data.settings.speechSynthesis.languages[0] ?? "Danish",
          secondaryLanguage: data.settings.speechSynthesis.languages[1] ?? null
        }
      }
    }
  };
}
function transformV1Task(v1Task, data) {
  const helpTexts = data.helpTexts[v1Task.id];
  const conditions = data.progressConditions[v1Task.id];
  return {
    type: "task",
    id: v1Task.id,
    title: v1Task.title,
    hints: helpTexts?.map(it => ({
      showAtAttempt: it.attempt,
      text: it.text
    })) ?? [],
    conditions: conditions ?? null
  };
}

/**
 * NB: See ADO #133697, #135302 for conversion details
 */
function transformSettignsToFlowType(data, envelope) {
  if (data.settings.progression === "conditional") {
    return "conditional";
  }
  const hasRandomizedFolder = data.course.some(it => "type" in it && it.type === "folder");
  if (!data.feedback.frequency.report && !data.feedback.frequency.validation) {
    return "no-feedback";
  }

  // Fast rækkefølge | Fast progression | Feedback ved resultatstatistik
  if (data.settings.taskOrder === "fixed" && data.settings.progression === "fixed" && data.feedback.frequency.report && !data.feedback.frequency.validation) {
    return envelope.Type === "opgavekompleks-simpel" ? hasRandomizedFolder ? "training-random" : "training-in-order" : "test-in-order";
  }

  // Tilfældig rækkefølge | Fast progression | Feedback ved resultatstatistik
  if (data.settings.taskOrder === "random" && data.settings.progression === "fixed" && data.feedback.frequency.report && !data.feedback.frequency.validation) {
    return envelope.Type === "opgavekompleks-simpel" ? "training-random" : "test-random";
  }

  // Tilfældig rækkefølge | Fri progression | Feedback ved resultatstatistik
  if (data.settings.taskOrder === "random" && data.settings.progression === "free" && data.feedback.frequency.report && !data.feedback.frequency.validation) {
    return "training-random";
  }

  // Fast rækkefølge | Fast progression | Feedback ved resultatstatistik + Når
  // man forlader opgave
  if (data.settings.taskOrder === "fixed" && data.settings.progression === "fixed" && data.feedback.frequency.report && data.feedback.frequency.validation) {
    return "training-in-order";
  }

  // Tilfældig rækkefølge | Fast progression | Feedback ved resultatstatistik +
  // Når man forlader opgave
  if (data.settings.taskOrder === "random" && data.settings.progression === "fixed" && data.feedback.frequency.report && data.feedback.frequency.validation) {
    return "training-random";
  }
  return envelope.Type === "opgavekompleks-simpel" && hasRandomizedFolder || data.settings.taskOrder === "random" ? "training-random" : "training-in-order";
}

export { transformOpgaveKompleksetV1DataToV2 };
//# sourceMappingURL=transformer.v1-v2.js.map
